export default __webpack_public_path__ + "static/media/create-class.be892b10.png";